// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import useGateOverride from 'crm-activity-creator-interactions-legacy/crm_ui/profile/hooks/useGateOverride';
export const useIsUngated = (gate, gates) => {
  const isUngatedFromGates = (gateName, authGates) => {
    return authGates && authGates.includes(gateName);
  };
  const isUngatedFromGateOverride = useGateOverride(gate);
  return isUngatedFromGateOverride || isUngatedFromGates(gate, gates);
};